<div class="flex-container-layout">
  <div class="flex-item">
    <div *ngIf="bookLaunchOffer" class="flex-container">

      <div class="flex-container-headline">

        <h1>Save Big on your Book's Launch</h1>

        <app-countdown [timeInSeconds]="bookLaunchOffer.countdown" (expired)="onCountdownDone($event)"
                       class="countdown"></app-countdown>

      </div>

      <app-book-launch-offer-default-item [bookLaunchOffer]="bookLaunchOffer" [tier]="bookLaunchOffer.defaultTier"
                                          [disabled]="countdownExpired">

      </app-book-launch-offer-default-item>


      <h2>Other available options ... </h2>

      <div class="tiers-container">

        <div class="tiers">
          <app-book-launch-offer-item [tier]="tier" [disabled]="countdownExpired" (selectTier)="selectTier($event)"
                                      *ngFor="let tier of bookLaunchOffer.tiersWithoutDefault"></app-book-launch-offer-item>

        </div>

        <div class="tier-details">
          <app-book-launch-offer-item-details [bookLaunchOffer]="bookLaunchOffer"
                                              [tier]="activeTier"></app-book-launch-offer-item-details>
        </div>

      </div>

    </div>

  </div>
</div>
